<template>
    <div class="terms-page" :class="{ 'terms-page--dark': $vuetify.theme.dark }">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12">
                    <TermsAndConditionTabs></TermsAndConditionTabs>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import TermsAndConditionTabs from '@/components/PagesComponents/TermsAndCondition/TermsAndConditionTabs.vue';
export default {
    components: { TermsAndConditionTabs },
}
</script>
<style scoped>
.terms-page {
    box-sizing: border-box;
    height: calc(100vh - 64px);
    min-height: 0;
    padding: 16px 18px;
    overflow-y: auto;
    background: #f7f8fa;
    scrollbar-width: thin;
    scrollbar-color: #dfe4ee transparent;
}
.terms-page--dark {
    background: radial-gradient(circle at 65% 16%, rgba(255, 196, 0, .055), transparent 35%), #030b13;
    scrollbar-color: #293026 transparent;
}
.terms-page::-webkit-scrollbar { width: 6px; }
.terms-page::-webkit-scrollbar-track { background: transparent; }
.terms-page::-webkit-scrollbar-thumb { border-radius: 10px; background: #dfe4ee; }
.terms-page--dark::-webkit-scrollbar-thumb { background: #293026; }
.terms-page ::v-deep .custom-container { max-width: none; padding: 0; }
@media (max-width: 760px) {
    .terms-page { height: calc(100dvh - 56px); padding: 12px 10px; }
}
</style>
